import React, { Component } from 'react';
import { StackedBarChart , LegendComp } from '../../../common/graph/bar-graph.component';
import { ChartHeaderDropdown } from '../../../common/data-header/chart-header-dropdown.component';
import '../report-page.component.css';

const graphData = [
    { name: 'APAC', rejected: 1, cancelled: 2, waitingforauthorization: 3, approved: 2, inprogress: 1, completed:4},
    { name: 'WE', rejected: 2, cancelled: 4, waitingforauthorization: 5, approved: 1, inprogress: 2, completed:5},
    { name: 'SEE', rejected: 1, cancelled: 3, waitingforauthorization: 4, approved: 1, inprogress: 1, completed:6},
    { name: 'NE', rejected: 3, cancelled: 2, waitingforauthorization: 4, approved: 3, inprogress: 1, completed:4},
    { name: 'LAT', rejected: 2, cancelled: 1, waitingforauthorization: 3, approved: 1, inprogress: 3, completed:5}
  ];

const  barData = [ {dataKey: 'rejected', name: 'Rejected', color:'#919eab'}, 
    {dataKey: 'cancelled', name: 'Cancelled', color:'#d5002f'}, 
    {dataKey: 'waitingforauthorization', name: 'Waiting for Authorization', color:'#ffc82c'}, 
    {dataKey: 'approved', name: 'Approved', color:'#00baff'}, 
    {dataKey: 'inprogress', name: 'In Progress', color:'#008eff'}, 
    {dataKey: 'completed', name: 'Completed', color:'#7ec344'}
]

const countData = [{ total: '500', description:'Total Count of Request'}]

class TemReqComp extends Component {
    render() {
        return (
            <div className="component-container legend-center">               
                <ChartHeaderDropdown haveOneIcone={true} haveIconInfo={true} iconInfo="info-circle-solid" haveLedger={false} ledger={barData} headerName="Weekly TEM Request Status Per Region" circleIcon={false} circleFirstIcon="list-regular" circleSecondIcon="th-solid" oneIcon="vertical-grid" 
                   haveInput={false} haveDropdown={false} totalCount={true}  countData={countData}  />
                <StackedBarChart data={graphData} barData={barData} displayLegend={true} legendData={barData}/>  
                <LegendComp data={barData} />                  
            </div>
        )
    }
}

export default TemReqComp;